import { GTMediaCampaign } from './gtMediaCampaign';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
GTMediaCampaign;

const props = [];

export const GTMediaCampaignDirective = reactDirective => reactDirective(GTMediaCampaign, props);
GTMediaCampaignDirective.$inject = ['reactDirective'];

// eslint-disable-next-line no-undef
angular.module('WB.App').directive('gTMediaCampaign', GTMediaCampaignDirective);
